module.exports = __webpack_public_path__ + "img/reload_button.84c4e2f0.svg";